export default 'icon--external';